import Input from './src/JsmInput.vue'

Input.install = (Vue) => {
  Vue.component(Input.name, Input)
}

export default Input
